// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in vue.config.js with an alias.
import Vue from 'vue'
import App from './App'
import 'lib-flexible'
import '@/styles/index.less' // global css

import { baseUrl, h5BaseUrl,pointsBaseUrl } from './utils/urlConfig'
let urlConfig = { baseUrl, h5BaseUrl,pointsBaseUrl }
Vue.prototype.$urlConfig = urlConfig	//公共地址管理

import 'babel-polyfill'
// Es6Promise
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

// filters
import * as filters from './filters'
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

// Vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// // axios
// import Api from './api/index';
// Vue.prototype.$api = Api;

//Vconsole
import Vconsole from 'vconsole'
if (['development','test', 'uat'].includes(process.env.VUE_APP_ENV || process.env.NODE_ENV)) {//'development',
    let vConsole = new Vconsole()
    Vue.use(vConsole)
}

// storage
import storage from './utils/storage'
Vue.prototype.$storage = storage

import fun from './utils/fun'
Vue.prototype.$fun = fun;

//vuex
import store from './store'

// cope
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

// router
import router from './router'
router.beforeEach((to, from, next) => {
    // console.log(to);
    // console.log(from);
    if (to.name) {
        document.title = to.name
    }
    next();
});

import Bridge from 'dsbridge'
Vue.prototype.$bridge = Bridge


// import wx from "weixin-js-sdk";
// Vue.prototype.$wx = wx

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
